import type { IconProps } from './types';

export const LogoutIcon: React.FC<IconProps> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth={1.5} {...props}>
            <rect width="24" height="24" fill="none" />
            <g transform="translate(2176 -3614)">
                <path
                    d="M19,10H12a3,3,0,0,0-3,3V23a3,3,0,0,0,3,3h7"
                    transform="translate(-2182 3608)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <line
                    x2="10"
                    transform="translate(-2165 3626)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.465,14.465,27,18l-3.536,3.535"
                    transform="translate(-2182 3608)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};
